var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"value":_vm.value,"options":_vm.timezones,"label":"zone","track-by":"zone","name":"timezone","disabled":_vm.disabled},on:{"input":_vm.onInput},scopedSlots:_vm._u([{key:"option",fn:function(props){return [_c('span',{staticClass:"block"},[_vm._v(_vm._s(props.option.zone)+" ("+_vm._s(props.option.offset)+")")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }